import { Tag } from 'antd'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { NAMESPACE } from 'locale'
import { carePlansConstants } from 'locale/carePlans'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import FluidLineIcon from './FluidLineIcon'
import { useGetCarePlanFluidIntake } from './hooks/useGetCarePlanFluidIntake'

interface FluidsDisplayProps {
  residentId: string
  flag: string
  displayInactiveState?: boolean
  displayIcon?: boolean
  mock?: boolean
}

const FluidsDisplay = ({
  residentId,
  flag,
  displayInactiveState = false,
  displayIcon = false,
  mock = false
}: FluidsDisplayProps) => {
  const flags = useFeatureFlags({ flagNames: [`${flag}`] })?.data
  const { t } = useTranslation(NAMESPACE.CARE_PLANS)

  const fluidTrackingFlagEnabled = flags[flag].enabled

  const { carePlanData } = useGetCarePlanFluidIntake(
    residentId,
    fluidTrackingFlagEnabled,
    mock
  )

  if (!fluidTrackingFlagEnabled) return null

  if (!carePlanData?.fluidTracking) {
    return displayInactiveState ? (
      <Container>
        <StyledTagInactive bordered>
          {t(carePlansConstants.NO_CURRENT_TARGET)}
        </StyledTagInactive>
      </Container>
    ) : null
  }

  const { enabled, intakeTarget } = carePlanData.fluidTracking

  if (!enabled) {
    return displayInactiveState ? (
      <Container>
        <StyledTagInactive bordered>
          {t(carePlansConstants.NO_CURRENT_TARGET)}
        </StyledTagInactive>
      </Container>
    ) : null
  }

  return (
    <Container>
      <StyledTag bordered>
        {t(carePlansConstants.DAILY_INTAKE_TARGET_ML, {
          intakeTarget
        })}
      </StyledTag>
      {displayIcon && <FluidLineIcon />}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
`

const StyledTag = styled(Tag)`
  && {
    font-size: 14px;
    font-weight: 500;
    border-color: #ff6699;
    color: #ff6699;
    background: rgba(255, 102, 153, 0.1);
  }
`

const StyledTagInactive = styled(Tag)`
  && {
    font-size: 14px;
    font-weight: 500;
    border-color: #acacac;
    color: #989898;
    background: rgba(172, 172, 172, 0.1);
  }
`

export default FluidsDisplay
